import PropTypes from "prop-types";
import React from "react";
import AutoSizer from "react-virtualized/dist/commonjs/AutoSizer";
import Inspector from "react-json-inspector";

const JsonView = props =>
  props.usingTextArea ? (
    <AutoSizer disableWidth>
      {({ height }) => (
        <div>
          <p>
            Searching is disabled because this dataset is very large. You can
            still use your browsers search function with ⌘F or Control-F.
          </p>
          <textarea style={{ width: "100%", height: height - 420 }} readOnly>
            {props.stringifiedData}
          </textarea>
        </div>
      )}
    </AutoSizer>
  ) : (
    <Inspector
      search={false}
      syle={{ marginTop: 20, padding: 0 }}
      data={props.dataClone}
      className="abc"
      filterOptions={{ ignoreCase: true }}
      query={props.formJsonModalSearchText}
      isExpanded={keyPath =>
        keyPath.split(".").length < props.jsonModalDisplayLevels &&
        keyPath !== "@attributes" &&
        keyPath.indexOf("Stage_Photo") < 0
      }
    />
  );
JsonView.propTypes = {
  dataClone: PropTypes.shape({}).isRequired,
  jsonModalDisplayLevels: PropTypes.number.isRequired,
  stringifiedData: PropTypes.string.isRequired,
  formJsonModalSearchText: PropTypes.string.isRequired,
  usingTextArea: PropTypes.bool.isRequired
};
export default JsonView;
